<template>
  <div class="ShouHuoKanban">
    <div>
      <h1 class="ShouHuoKanbanTitle" style="text-align:center; margin: 0vh 0vh 2vh 0; line-height: 9vh;">收货处电子看板</h1>
      <h1 class="ShouHuoKanbanTitle">当日生产缺料清单</h1>
      <el-table
          :data="data1"
          size="medium"
          style="font-size: 2.6vh;"
          height="300"
          border
          :row-class-name="tableRowClassName">
        <el-table-column prop="arrivedTime" label="到货时间" align="center" width="300"/>
        <el-table-column prop="supplierName" label="供应商" align="center" width="400"/>
        <el-table-column prop="sapmaterialNO" label="物料号" align="center" width="200"/>
        <el-table-column
            prop="sapmaterialName"
            label="物料描述"
            align="center"
            width="400"
            show-overflow-tooltip/>
        <el-table-column prop="instockQuantity" label="数量" align="center" width="100"/>
        <el-table-column prop="factoryNo" label="出厂编号" align="center" width="200"/>
        <el-table-column prop="location" label="库位" align="center" width="100"/>
        <el-table-column prop="statusName" label="状态" align="center"/>
      </el-table>
    </div>
    <h1 class="ShouHuoKanbanTitle">待入库清单</h1>
    <div id="secondTable" class="secondTable">
      <el-table
          :data="data2"
          size="medium"
          border
          style="font-size: 2.6vh;"
          :height="secondTableHeight"
          :row-class-name="tableRowClassName">
        <el-table-column prop="arrivedTime" label="到货时间" align="center" width="300"/>
        <el-table-column prop="supplierName" label="供应商" align="center" width="400"/>
        <el-table-column prop="sapmaterialNO" label="物料号" align="center" width="200"/>
        <el-table-column
            prop="sapmaterialName"
            label="物料描述"
            align="center"
            width="400"
            show-overflow-tooltip/>
        <el-table-column prop="instockQuantity" label="数量" align="center" width="100"/>
        <el-table-column prop="factoryNo" label="出厂编号" align="center" width="200"/>
        <el-table-column prop="location" label="库位" align="center" width="100"/>
        <el-table-column prop="statusName" label="状态" align="center"/>
      </el-table>
    </div>
  </div>
</template>

<script>
  import "echarts-liquidfill";

  export default {
    data() {
      return {
        allData: [],
        data1: [],//当日生产缺料清单
        data2: [],//待入库清单
        showData1:[],
        showData2:[],
        secondTableHeight: 300,
      };
    },
    mounted() {
      this.getData();
      setInterval(() => {
        this.getData();
      }, 1000 * 60 * 5);

      setInterval(()=>{
        this.data1.push(this.data1[0]);
        this.data1.splice(0,1);
      },1000 * 5);

      setInterval(()=>{
        this.data2.push(this.data2[0]);
        this.data2.splice(0,1);
      },1000 * 5);


    },
    methods: {
      getSecondTableHeight() {
        this.$nextTick(() => {
          const el = document.getElementById("secondTable");
          this.secondTableHeight = el.offsetHeight;
        });
      },
      getData() {
        this.$http.get("basic", "kanban/getReceiveKanBanVO").then(res => {
          this.allData = res;
          this.allData.forEach((item) => {
            if (item.arriveStatus === 0) {
              this.data1.push(item);
            } else {
              this.data2.push(item);
            }
          });
          this.getSecondTableHeight();
        });
      },

      tableRowClassName({row,rowIndex}) {
        if (row.arriveStatus === 0) {
          return "warning-row";
        } else if (row.arriveStatus === 1) {
          return "success-row";
        }
        return "";
      },
    },

  };
</script>

<style lang="scss">
.ShouHuoKanban {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: url("/img/kanban_bg.png") no-repeat;
  background-size: 100% 100%;

  .secondTable {
    flex: 1;
    overflow: hidden;
  }

  .ShouHuoKanbanTitle {
    text-align: center;
    color: white;
  }

  .el-table, .el-table__expanded-cell, .el-table th, .el-table tr {
    background-color: transparent !important;
    color: #fff;
  }

  ::-webkit-scrollbar, ::-webkit-scrollbar-track {
    background-color: transparent !important;
  }

  .el-table__body tr:hover > td {
    background-color: #263445 !important;
  }

  .el-table__body tr.current-row > td {
    background-color: #263445 !important;
  }

  .clear {
    clear: both
  }

  .el-table .warning-row {
    color: red;
  }

  .el-table .success-row {
    color: yellow;
  }
}
</style>